const complyRegulator = (
  { market }: { market: string },
  regulatedMarket: string,
) => market === regulatedMarket;

export default complyRegulator;
